import Logo from './images/koganpage.png';
export let SERVER_URL = "https://koganpage.novareader.co/";
export const APP_NAME="Kogan Page";
export const LOGO=Logo;


